import { getCrmContainerContentId } from '../utils/crmContainerContentUtils';
export const createContainerContentKey = (containerId, content, index) => {
  return `container:${containerId}:contentId:${content.type}:${getCrmContainerContentId(content)}:${index ? `index:${index}` : ''}`;
};